import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";

import { AppState } from "../../states/app-state.interface";
import { Auth } from "../../models/auth.model";
import { AuthActions } from "../../states/auth";
import { AuthProvider } from "../../providers/auth/auth";
import { AuthResponse } from "../../models/responses/auth.response";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ProjectsActions } from "../../states/v2/projects";
import { Store } from "@ngrx/store";

@Injectable()
export class AuthRepository {
  public auth$ = this.store.select((s) => s.auth);
  public isUser$ = this.auth$.map((res) => res.isAuthenticated);
  public isAdmin$ = this.auth$.map(
    (res) => res.isAuthenticated && res.user.role == 0
  );

  constructor(
    private store: Store<AppState>,
    private authActions: AuthActions,
    private projectActions: ProjectsActions,
    private auth: AuthProvider
  ) {}

  public login(credentials) {
    return this.auth
      .login(credentials)
      .map((res) => {
        let auth = Auth.create(res);
        this.store.dispatch(this.authActions.setAuthentication(auth));
        return auth;
      })
      .catch((response) => {
        this.onError(JSON.stringify(response.error));
        return Observable.of(undefined);
      });
  }

  public logout() {
    return this.auth
      .logout()
      .map((res) => {
        this.logoutWithApiCall();
      })
      .catch((response) => {
        this.onError(JSON.stringify(response.error));
        return Observable.of(undefined);
      });
  }

  public logoutWithApiCall() {
    this.store.dispatch(this.projectActions.deleteAll());
    this.store.dispatch(this.authActions.clearAuthentication());
  }

  public forgot(credentials) {
    return this.auth
      .forgot(credentials)
      .map((res) => {
        return res;
      })
      .catch((response) => {
        this.onError(JSON.stringify(response.error));
        return Observable.of(undefined);
      });
  }

  public activate(credentials) {
    return this.auth
      .activate(credentials)
      .map((res) => {
        let auth = Auth.create(res as AuthResponse);
        // if (res.api_token) {
        this.store.dispatch(this.authActions.setPasswordIsReset());
        // setTimeout(() => {
        this.store.dispatch(this.authActions.setAuthentication(auth));
        // }, 500);
        // }
        return auth;
      })
      .catch((response) => {
        this.onError(JSON.stringify(response.error));
        return Observable.of(undefined);
      });
  }

  public reset(credentials) {
    return this.auth
      .reset(credentials)
      .map((res) => {
        if (res.api_token) {
          this.store.dispatch(this.authActions.setPasswordIsReset());
          setTimeout(() => {
            this.store.dispatch(
              this.authActions.setAuthentication({
                apiToken: res.api_token,
                user: res.user,
              })
            );
          }, 500);
        }
        return res;
      })
      .catch((response) => {
        this.onError(JSON.stringify(response.error));
        return Observable.of(undefined);
      });
  }

  public me() {
    return this.auth
      .me()
      .map((res) => {
        let auth = Auth.create(res);
        this.store.dispatch(this.authActions.me(auth));
        return auth;
      })
      .catch((response) => {
        this.onError(JSON.stringify(response.error));
        return Observable.of(undefined);
      });
  }

  public ping() {
    return this.auth.ping();
  }

  private onError(response) {
    if (response) {
      this.store.dispatch(this.authActions.setError(response.error));
    }
  }
}



// WEBPACK FOOTER //
// ./src/repositories/auth/auth.repository.ts